var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7778 4.94447V3.16669C10.7778 2.6952 10.5905 2.24301 10.2571 1.90961C9.92368 1.57622 9.4715 1.38892 9 1.38892H2.77778C2.30628 1.38892 1.8541 1.57622 1.5207 1.90961C1.1873 2.24301 1 2.6952 1 3.16669V13.8334C1 14.3049 1.1873 14.757 1.5207 15.0904C1.8541 15.4238 2.30628 15.6111 2.77778 15.6111H9C9.4715 15.6111 9.92368 15.4238 10.2571 15.0904C10.5905 14.757 10.7778 14.3049 10.7778 13.8334V12.0556M6.33333 8.50003H17M17 8.50003L14.3333 5.83336M17 8.50003L14.3333 11.1667",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.a3cb76f73123503654f89099d85493b5.svg";
export { ForwardRef as ReactComponent };